import React from 'react';
import SelectList from 'react-widgets/lib/SelectList';
import BareTextItem from '../../../containers/QuestionnaireItems/BareText';
import { QuestionnaireItemComponent } from '../../../modules/unsw-fhir/Questionnaire';
import { IndicatorStateOptions } from '../../Indicator';

const Item = (props: QuestionnaireItemComponent) =>
  (props.type === 'string' && <BareTextItem {...props} />) || null;

export interface OptionItem {
  id: string;
  display: string;
  code: string;
  data: any;
  exclusive?: boolean;
}

export type TableInputProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  indicatorState?: IndicatorStateOptions;
  text?: string;
  enabled?: boolean;
  error?: string;
  disabled?: boolean;
  name: string;
  check?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
  required?: boolean;
  options?: OptionItem[];
  item?: QuestionnaireItemComponent[];
  border?: boolean;
};

const TableInput = (props: TableInputProps) => {
  const { enabled, item: items = [], options = [] } = props;

  return enabled === undefined || enabled ? (
    <>
      <div>{props.text}</div>
      {options.map(option => (
        <SelectList
          key={`${props.name}-${option.code}`}
          name={props.name}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          onChange={(value?: any) => {
            if (!props.onChange) return;
            props.onChange(value?.code);
          }}
          value={
            options ? options.find(x => x.code === props.value) : undefined
          }
          disabled={props.disabled}
          data={[option]}
          textField="display"
          valueField="id"
        />
      ))}
      {items.map(item => (
        <div key={item.linkId}>
          <Item {...item} />
        </div>
      ))}
    </>
  ) : null;
};

export default TableInput;
